import { render, staticRenderFns } from "./MediaPickerDialog.vue?vue&type=template&id=540c7ab9&scoped=true&"
import script from "./MediaPickerDialog.vue?vue&type=script&lang=js&"
export * from "./MediaPickerDialog.vue?vue&type=script&lang=js&"
import style0 from "./MediaPickerDialog.vue?vue&type=style&index=0&id=540c7ab9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c7ab9",
  null
  
)

export default component.exports